import React from 'react';
import { useAudioController } from '@store/audio/AudioController';
import { clearQueue } from '@store/audio/AudioQueue';
import { QueueListSection } from './QueueListSection';

export const QueueList = ({
  scrollToTop,
  scrollParent,
}: {
  scrollToTop: () => void;
  scrollParent?: HTMLDivElement;
}) => {
  const { activeTrackId, activeTrackIndex, queueTrackIds, upNextTrackIds, playing } =
    useAudioController();

  return (
    <>
      <QueueListSection
        activeTrackIndex={activeTrackIndex}
        heading="Playing Now"
        sectionStartingIndex={0}
        trackIds={activeTrackId ? [activeTrackId] : []}
        playing={playing}
        scrollToTop={scrollToTop}
        scrollParent={scrollParent}
      />
      <QueueListSection
        activeTrackIndex={activeTrackIndex}
        clearAll={clearQueue}
        deleteEnabled
        heading="Next in Queue"
        sectionStartingIndex={1}
        trackIds={queueTrackIds}
        scrollToTop={scrollToTop}
        scrollParent={scrollParent}
      />
      <QueueListSection
        activeTrackIndex={activeTrackIndex}
        heading="Up Next"
        sectionStartingIndex={queueTrackIds.length + 1}
        trackIds={upNextTrackIds}
        scrollToTop={scrollToTop}
        scrollParent={scrollParent}
      />
    </>
  );
};
